import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AppProvider } from "./src/context/app-context";
import "./src/components/layout/layout.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return <AppProvider>{element}</AppProvider>;
};
